import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Pattern A: Central Auth + Central User Data

// CENTRAL FIREBASE CONFIG (for Auth AND User Data)
const centralConfig = {
  apiKey: "AIzaSyCBiN-A6HsyefXYJglf29lNcScY5Yirw7U",
  authDomain: "paymentgateway-ab783.firebaseapp.com",
  projectId: "paymentgateway-ab783",
  storageBucket: "paymentgateway-ab783.appspot.com",
  messagingSenderId: "847215626392",
  appId: "1:847215626392:web:99e2db60da4361fa01d651"
};

// LOCAL FIREBASE CONFIG (for App Data only)
const localConfig = {
  apiKey: process.env.REACT_APP_LOCAL_FIREBASE_API_KEY || "AIzaSyBK-mUY80Ht8SscNIaRrEEmI6Hg-AVgt7M",
  authDomain: process.env.REACT_APP_LOCAL_FIREBASE_AUTH_DOMAIN || "booker-1d469.firebaseapp.com",
  projectId: process.env.REACT_APP_LOCAL_FIREBASE_PROJECT_ID || "booker-1d469",
  storageBucket: process.env.REACT_APP_LOCAL_FIREBASE_STORAGE_BUCKET || "booker-1d469.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_LOCAL_FIREBASE_MESSAGING_SENDER_ID || "1090460103428",
  appId: process.env.REACT_APP_LOCAL_FIREBASE_APP_ID || "1:1090460103428:web:99e2db60da4361fa01d651",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-66TPRENESP"
};

// Initialize CENTRAL app (for Auth and User Data)
const centralApp = initializeApp(centralConfig, 'central');

// Initialize LOCAL app (for App Data only)
const localApp = initializeApp(localConfig, 'local');

// Auth (central)
export const auth = getAuth(centralApp);

// Central Firestore (user profiles, subscriptions)
export const db = initializeFirestore(centralApp, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  }),
  experimentalForceLongPolling: false,
  experimentalAutoDetectLongPolling: true
});

// Local Firestore (app data)
export const localDb = initializeFirestore(localApp, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  }),
  experimentalForceLongPolling: false,
  experimentalAutoDetectLongPolling: true
});

// Storage (local)
export const storage = getStorage(localApp);
// ✅ PATTERN A: CLEAN IMPLEMENTATION (No Workarounds Needed!)
// ═══════════════════════════════════════════════════════════════════════
// The backend uses verifyMultiProjectToken() to accept auth tokens from EITHER:
// 1. Central project (paymentgateway-ab783) - most common
// 2. Local project (booker-1d469) - legacy support
//
// This means:
// ✅ Users sign in ONCE with central auth
// ✅ Backend automatically accepts central auth tokens
// ✅ No custom token workaround needed
// ✅ No duplicate user creation in local Firebase Auth
//
// See backend: functions/src/config/firebase.ts → verifyMultiProjectToken()
// See backend: functions/src/middleware/auth.ts → authenticateUser()
// ═══════════════════════════════════════════════════════════════════════

// Export local app as default (for compatibility)
export default localApp;